import PurchaseListTab from "./PurchaseListTab";

export default PurchaseListTab;
